import { render, staticRenderFns } from "./AllTemplates.vue?vue&type=template&id=708bda5b&scoped=true"
import script from "./AllTemplates.vue?vue&type=script&lang=js"
export * from "./AllTemplates.vue?vue&type=script&lang=js"
import style0 from "./AllTemplates.vue?vue&type=style&index=0&id=708bda5b&prod&lang=scss&scoped=true"
import style1 from "./AllTemplates.vue?vue&type=style&index=1&id=708bda5b&prod&lang=scss"
import style2 from "./AllTemplates.vue?vue&type=style&index=2&id=708bda5b&prod&lang=scss&scoped=true"
import style3 from "./AllTemplates.vue?vue&type=style&index=3&id=708bda5b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708bda5b",
  null
  
)

export default component.exports